import { observer } from 'mobx-react';
import { useCallback, useEffect, useRef } from 'react';
import { Checkbox } from '../../../../../../../../components/inputs/checkbox/checkbox';
import ListLayout from '../../../../../../../../components/layouts/list-layout/list-layout';
import { Note } from '../../../../../../../../components/note/note';
import '../../../../../../../home/components/terms-acceptance-modal/terms-acceptance-shared.scss';
import FedexV2EulaStore from '../../../../../stores/credentials/shipping/fedex-v2/fedex-v2-eula-store';
import {
    FEDEX_EULA_ACKNOWLEDGMENT_LABEL,
    FEDEX_STANDARD_EULA_TEXT,
} from '../fedex-standard-eula';

interface IProps {
    eula: FedexV2EulaStore;
}

const SCROLL_END_THRESHOLD_PX = 8;

const FedexV2RegistrationEulaStep: React.FC<IProps> = observer(({ eula }) => {
    const scrollRef = useRef<HTMLDivElement>(null);

    const updateScrollEnd = useCallback(() => {
        const element = scrollRef.current;
        if (!element || eula.hasScrolledToEnd) {
            return;
        }

        const atEnd =
            element.scrollHeight - element.scrollTop - element.clientHeight
            <= SCROLL_END_THRESHOLD_PX;

        if (atEnd || element.scrollHeight <= element.clientHeight) {
            eula.markScrolledToEnd();
        }
    }, [eula]);

    useEffect(() => {
        updateScrollEnd();
    }, [updateScrollEnd]);

    return (
        <ListLayout>
            <Note body="Scroll through the full FedEx End User License Agreement before you can accept." />
            <div
                ref={scrollRef}
                className="terms-acceptance-terms-box"
                aria-label="FedEx End User License Agreement"
                onScroll={updateScrollEnd}
            >
                <pre className="terms-acceptance-terms-text">{FEDEX_STANDARD_EULA_TEXT}</pre>
            </div>
            <div className="terms-acceptance-checkbox">
                <Checkbox
                    label={FEDEX_EULA_ACKNOWLEDGMENT_LABEL}
                    checked={eula.acknowledged}
                    onChange={eula.setAcknowledged}
                    disabled={!eula.hasScrolledToEnd}
                />
            </div>
        </ListLayout>
    );
});

export default FedexV2RegistrationEulaStep;
